<template>
  <div class="echart" ref="echart" :style="echartStyle"></div>
</template>

<script>
import echart from "@/utils/echart";
export default {
  props: {
    echartStyle: {
      type: Object,
      default() {
        return { 
          width: '100%',
          height: '100%'
         };
      },
    },
    cusList: {
      type: Array,
      default() {
        return [];
      },
    },
    isScale: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    options() {
      return {
        grid: {
          left: '3%',
          right: '10%',
          bottom: '10%',
          containLabel: true,
          top: '10%'
        },
        tooltip: {},
        xAxis: {
          show: false,
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          data: this.cusList.map(v=>v.name).reverse(),
          axisLabel: {
            show: true,
            interval: 0,
            formatter: function (value) {
              return (value.length > 8 ? (value.slice(0,8)+"...") : value )
            },
          },
        },
        series: [
          {
            type: 'bar',
            data: this.cusList.map(v=>v.total).reverse(),
            itemStyle: {
            normal: {
                color: "#24c69a",
                label: {
                  show: true, //开启显示
                  position: 'right', //顶部显示
                },
                borderRadius: [0, 20, 20, 0],
              },
            },
            barWidth: 16
          },
        ]
      }
    },
  },
  watch: {
    options: {
      handler() {
        this.init()
      },
      deep: true
    }
    
  },
  data() {
    return {};
  },
  methods: {
    init() {
      const divFef = this.$refs.echart;
      const { setData } = echart(divFef);
      setData(this.options);
    },
  },
  mounted() {
  //  this.init()
  },
};
</script>

<style lang="stylus" scoped></style>
